<template>
  <v-container class="px-9">
    <div class="pr-2 pt-4">
      <h2
        class="common-text-alignment d-flex justify-space-between align center"
      >
        RFM Settings
        <v-btn
          icon
          @click.stop="onCloseDrawer"
          v-track="`erfm-settings-cancel`"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </h2>
    </div>
    <div class="subtitle-1 mt-2 mb-6">Configuration / setup the RFM module.</div>
    <v-form ref="settingsForm" v-model="valid" class="px-1">
      <v-divider></v-divider>
      <v-row class="px-4">
        <v-col cols="12">
          <div
            @click="showComponent('recency')"
            class="d-flex justify-space-between cursor-pointer"
            v-track="`erfm-settings-recency`"
          >
            <div class="sub-heading-text">Recency Definitions</div>
              <v-icon >{{showRecency?'mdi-menu-up':'mdi-menu-down'}}</v-icon>
          </div>
        </v-col>
        <v-col cols="12" class="mb-2" v-if="showRecency">
          <v-alert dense class="pl-2 ml-n2" color="#f2f2f2">
            <span class="subtitle-2 font-grey"
              >Recency scores</span
            >
            <p class="body-2 mt-2 font-grey">
              Recency is based on the number of days since the contact’s last
              purchase. A higher score means the contact made a purchase more
              recently.
            </p>
          </v-alert>
          <section class="mb-3">
            <div class="sub-heading-text mb-2 mt-8 ">Score of 3 (highest)</div>
            <span class="body-1 font-grey">Maximum days since purchase</span>
            <p class="body-2 font-grey">
              Customers who purchased between now and this many days ago get a
              score of 3.
            </p>
            <v-col cols="8" class="pa-0">
              <v-text-field
                label="Days"
                :readonly="!readyToEdit"
                @focus="formInteracted = true"
                outlined
                v-model="settings.recency.highestScoreDays"
                class="mt-4"
                @input="validateAllFields"
                :rules="[isNumberRule, (v) => highestScoreRule(v, 'recency'),maxValueRule]"
              ></v-text-field>
            </v-col>
          </section>
          <section class="mb-3">
            <div class="sub-heading-text mb-2">Score of 2 (average)</div>
            <span class="body-1 font-grey">Maximum days since purchase</span>
            <p class="body-2 font-grey">
              Customers who purchased between this many days ago and the value
              above get a score of 2.
            </p>
            <v-col cols="8" class="pa-0">
              <v-text-field
                label="Days"
                :readonly="!readyToEdit"
                @focus="formInteracted = true"
                outlined
                v-model="settings.recency.averageScoreDays"
                class="mt-4"
                @input="validateAllFields"
                :rules="[isNumberRule, (v) => averageScoreRule(v, 'recency'),maxValueRule]"
              ></v-text-field>
            </v-col>
          </section>
          <section class="mb-3">
            <div class="sub-heading-text mb-2">Score of 1 (below average)</div>
            <span class="body-1 font-grey">Maximum days since purchase</span>
            <p class="body-2 font-grey">
              Customers who purchased between this many days ago and the value
              above get a score of 1.
            </p>
            <v-col cols="8" class="pa-0">
              <v-text-field
                label="Days"
                :readonly="!readyToEdit"
                @focus="formInteracted = true"
                outlined
                v-model="settings.recency.lowestScoreDays"
                class="mt-4"
                @input="validateAllFields"
                :rules="[isNumberRule, (v) => lowestScoreRule(v), maxValueRule]"
              ></v-text-field>
            </v-col>
          </section>
          <v-alert
            dense
            icon="mdi-information-outline"
            class="body-2 mb-6 mt-8"
            color="#f2f2f2"
          >
            <span class="subtitle-2">Score of 0 (lowest)</span>
            <div class="body-2 font-grey">
              MINIMUM days since purchase.
            </div>
            <p class="body-2 font-grey">Customers who purchased more than {{ settings.recency.lowestScoreDays }}
              days ago get a score of 0.</p>
          </v-alert>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="px-4">
        <v-col cols="12">
          <div
            @click="showComponent('frequency')"
            class="d-flex justify-space-between cursor-pointer"
            v-track="`erfm-settings-frequency`"
          >
            <div class="sub-heading-text">Frequency Definitions</div>
              <v-icon>{{showFrequency?'mdi-menu-up':'mdi-menu-down'}}</v-icon>
          </div>
        </v-col>
        <!-- frequency from here -->
        <v-col cols="12" class="mb-2" v-if="showFrequency">
          <v-alert dense class="pl-2 ml-n2" color="#f2f2f2">
            <span class="subtitle-2 font-grey"
              >Frequency scores</span
            >
            <p class="body-2 mt-2 font-grey">
              Frequency is the number of times a contact purchased during the
              timeframes selected in the Recency section". A higher score means
              the customer purchased more frequently
            </p>
          </v-alert>
          <section class="mb-3">
            <div class="sub-heading-text mb-2 mt-8">Score of 3 (most frequent)</div>
            <span class="body-1 font-grey"
              >Minimum number of purchases within the recency timeframe</span
            >
            <p class="body-2 font-grey">
              Customers with this value or higher get a score of 3.
            </p>
            <v-col cols="8" class="pa-0">
              <v-text-field
                label="Number of purchases"
                :readonly="!readyToEdit"
                @focus="formInteracted = true"
                outlined
                v-model="settings.frequency.mostFrequent"
                class="mt-4"
                @input="validateAllFields"
                :rules="[isNumberRule, (v) => highestScoreRule(v, 'frequency')]"
              ></v-text-field>
            </v-col>
          </section>
          <section class="mb-3">
            <div class="sub-heading-text mb-2">Score of 2 (average)</div>
            <span class="body-1 font-grey"
              >Minimum number of purchases within the recency timeframe</span
            >
            <p class="body-2 font-grey">
              Customers who purchased at least this many times but less than the
              value in 3 (in the defined time period) get a score of 2.
            </p>
            <v-col cols="8" class="pa-0">
              <v-text-field
                label="Number of purchases"
                :readonly="!readyToEdit"
                @focus="formInteracted = true"
                outlined
                v-model="settings.frequency.averagelyFrequent"
                class="mt-4"
                @input="validateAllFields"
                :rules="[isNumberRule, (v) => averageScoreRule(v, 'frequency')]"
              ></v-text-field>
            </v-col>
          </section>
          <v-alert
            dense
            icon="mdi-information-outline"
            class="body-2 mb-6 mt-8"
            color="#f2f2f2"
          >
            <span class="subtitle-2">Score of 1 (least frequent)</span>
            <p class="body-2 font-grey">
              is automatically assigned to customers who purchased fewer times
              than score 2 within the defined time frame.
            </p>
          </v-alert>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="px-4">
        <v-col cols="12">
          <div
            @click="showComponent('monetry')"
            class="d-flex justify-space-between cursor-pointer"
            v-track="`erfm-settings-monetary`"
          >
            <div class="sub-heading-text">Monetary Definitions</div>
              <v-icon>{{showMonetary?'mdi-menu-up':'mdi-menu-down'}}</v-icon>
          </div>
        </v-col>
        <!-- monetry from here -->
        <v-col cols="12" class="mb-2" v-if="showMonetary">
          <v-alert dense class="pl-2 ml-n2" color="#f2f2f2">
            <span class="subtitle-2 font-grey">Monetary value scores</span>
            <p class="body-2 mt-2 font-grey">
              Monetary scores is based on the total value of all purchases
              within the timeframes defined under Recency Definitions.
            </p>
          </v-alert>
          <section class="mb-3">
            <div class="sub-heading-text mb-2 mt-8">
              Score of 3 (highest spenders)
            </div>
            <span class="body-1 font-grey">Minimum total spend</span>
            <p class="body-2 font-grey">
              Customers who have spent this much or more within the defined time
              frames get a score of 3.
            </p>
            <v-col cols="8" class="pa-0">
              <v-text-field
                label="Dollar value"
                :readonly="!readyToEdit"
                @focus="formInteracted = true"
                outlined
                v-model="settings.monetary.highestSpender"
                class="mt-4"
                @input="validateAllFields"
                :rules="[isNumberRule, (v) => highestScoreRule(v, 'monetary')]"
              ></v-text-field>
            </v-col>
          </section>
          <section class="mb-3">
            <div class="sub-heading-text mb-2">
              Score of 2 (average spenders)
            </div>
            <span class="body-1 font-grey">Minimum total spend</span>
            <p class="body-2 font-grey">
              Customers who have spent this much or more, but less than the
              value in score 3 (within the defined time frames) get a score of
              2.
            </p>
            <v-col cols="8" class="pa-0">
              <v-text-field
                label="Dollar value "
                :readonly="!readyToEdit"
                @focus="formInteracted = true"
                outlined
                v-model="settings.monetary.averageSpender"
                class="mt-4"
                @input="validateAllFields"
                :rules="[isNumberRule, (v) => averageScoreRule(v, 'monetary')]"
              ></v-text-field>
            </v-col>
          </section>
          <v-alert
            dense
            icon="mdi-information-outline"
            class="body-2 mb-6 mt-8"
            color="#f2f2f2"
          >
            <span class="subtitle-2">Score of 1 (low spenders)</span>
            <p class="body-2 font-grey">
              is automatically assigned to customers who have spent less than
              the amount defined for Score 2 within the defined time periods.
            </p>
          </v-alert>
        </v-col>
      </v-row>
      <v-divider class="mb-2"></v-divider>
      <v-row>
        <v-col cols="12" class="px-6 mt-12">
          <v-btn
            v-track="`erfm-settings-cancel`"
            outlined
            @click="onCloseDrawer"
          >
            Cancel
          </v-btn>
          <v-btn
            v-track="`erfm-settings-apply`"
            class="ml-3"
            :disabled = "!readyToEdit || !valid || !formInteracted"
            :loading="loading"
            color="black white--text"
            @click="onSubmit"
          >
            Apply
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { $erfmReport } from "@/services/";

export default {
  data() {
    return {
      valid: false,
      loading: false,
      showFrequency: false,
      showRecency: false,
      showMonetary: false,
      readyToEdit:false,
      formInteracted:false,
      settings: {
        recency: {
          highestScoreDays: null,
          averageScoreDays: null,
          lowestScoreDays: null,
        },
        frequency: {
          mostFrequent: null,
          averagelyFrequent: null,
        },
        monetary: {
          highestSpender: null,
          averageSpender: null,
        },
      },
      maxValueRule: (value) => Number(value) <= 1000 || 'Recency days cannot exceed 1000',
      isNumberRule: (value) => {
        if (!value) {
          return "Value is required.";
        }
        const num = Number(value);
        if (isNaN(num)) {
          return "Please enter a valid number.";
        }
        if (num < 0) {
          return "Only positive numbers are allowed.";
        }
        if (num === 0) {
          return "Please enter a value greater than 0.";
        }
        return true;
      },
      highestScoreRule: (value, component) => {
        const numValue = Number(value);
        if (component === "recency") {
          if (
            numValue < (this.settings.recency.averageScoreDays || Number.MAX_SAFE_INTEGER) &&
            numValue < (this.settings.recency.lowestScoreDays || Number.MAX_SAFE_INTEGER)
          ) {
            return true;
          }
          return `value must be less than values of score of 2 and score of 1`;
        } else if (component === "frequency") {
          if (numValue > this.settings.frequency.averagelyFrequent) {
            return true;
          }
          return `value must be greater value of score of 2`;
        } else {
          if (numValue > this.settings.monetary.averageSpender) {
            return true;
          }
          return `value must be greater value of score of 2`;
        }
      },
      averageScoreRule: (value, component) => {
        const numValue = Number(value);
        if(component === 'recency') {
          if(numValue > (this.settings.recency.highestScoreDays||Number.MIN_SAFE_INTEGER) && numValue < (this.settings.recency.lowestScoreDays || Number.MAX_SAFE_INTEGER)) {
            return true;
          }
          return `value must be in between values of scores of 3 and score of 1`;
        } else if(component === 'frequency') {
          if(numValue < this.settings.frequency.mostFrequent) {
            return true;
          }
          return `value must be less than value of scores of 3`;
        } else {
          if(numValue < this.settings.monetary.highestSpender) {
            return true;
          }
          return `value must be less than value of scores of 3`;
        }
      },
      lowestScoreRule: (value) => {
        const numVal = Number(value);
        if(numVal > this.settings.recency.averageScoreDays && numVal > this.settings.recency.highestScoreDays) {
          return true;
        }
        return `value must be greater than the values of score of 2 and score of 3`;
      }
    };
  },
  mounted() {
    this.fetchERFMSettings();
  },
  methods: {
    onSubmit() {
      if (this.valid) {
        this.loading = true;
        const payload = {
          recency: {
            score_3: Number(this.settings.recency.highestScoreDays),
            score_2: Number(this.settings.recency.averageScoreDays),
            score_1: Number(this.settings.recency.lowestScoreDays),
          },
          frequency: {
            score_3: Number(this.settings.frequency.mostFrequent),
            score_2: Number(this.settings.frequency.averagelyFrequent),
          },
          monetary: {
            score_3: Number(this.settings.monetary.highestSpender),
            score_2: Number(this.settings.monetary.averageSpender),
          },
        };
        $erfmReport.saveERFMSettings(payload).then(() => {
          this.$store.commit('ui/snackbar', {
            message: 'Recalculation in progress. New settings will be applied shortly.',
            type: 'success',
          })
        }).finally(() => {
          this.readyToEdit = false;
          this.loading = false;
        });
      }
    },
    validateAllFields() {
      this.$refs.settingsForm.validate();
    },
    onCloseDrawer() {
      this.$store.commit("ui/drawer.right", {
        show: false,
        component: null,
        response: {},
      });
    },
    showComponent(type) {
      if (type === "frequency") {
        this.showFrequency = !this.showFrequency;
        this.showRecency = false;
        this.showMonetary = false;
      } else if (type === "recency") {
        this.showRecency = !this.showRecency;
        this.showFrequency = false;
        this.showMonetary = false;
      } else {
        this.showFrequency = false;
        this.showRecency = false;
        this.showMonetary = !this.showMonetary;
      }
    },
    async fetchERFMSettings() {
      let response = await $erfmReport.fetchERFMSettings();
      let data = response.data.data;
      this.readyToEdit = data.is_active;
      if(!data.is_active){
        this.$store.commit('ui/snackbar', {
            message: 'Recalculation in progress. New settings will be applied shortly.',
            type: 'warning',
          })
      }
      // Map recency scores to days
      const recencyScores = data.recency

      this.settings.recency.highestScoreDays = recencyScores.score_3;
      this.settings.recency.averageScoreDays = recencyScores.score_2;
      this.settings.recency.lowestScoreDays = recencyScores.score_1;

      // Map frequency scores to frequency categories
      const frequencyScores = data.frequency;
      this.settings.frequency.mostFrequent = frequencyScores.score_3.toLocaleString('fullwide', { useGrouping: false });
      this.settings.frequency.averagelyFrequent = frequencyScores.score_2.toLocaleString('fullwide', { useGrouping: false });

      // Map monetary scores to monetary categories
      const monetaryScores = data.monetary;
      this.settings.monetary.highestSpender = monetaryScores.score_3.toLocaleString('fullwide', { useGrouping: false });
      this.settings.monetary.averageSpender = monetaryScores.score_2.toLocaleString('fullwide', { useGrouping: false });
    },
  },
};
</script>
<style lang="scss" scoped>
.sub-heading-text {
  color: rgba(0, 0, 0, 0.87);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Montserrat;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.55px;
}

.font-grey {
  color: #606060;
}
</style>
